import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

// 1. Standard React mount (for development and standalone usage of Portal/Admin)
const rootElement = document.getElementById('root');
if (rootElement) {
  // We import CSS normally here for the standard mount
  import('./index.css').then(() => {
    createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
}

// 2. Web Component Definition for Embedding into Astro/External sites
// To isolate styles, we use Vite's ?inline query to get the raw CSS string.
import styles from './index.css?inline';

class FlowerOrderForm extends HTMLElement {
  constructor() {
    super();
    // Use Shadow DOM to prevent CSS conflicts with the host site
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    // Inject Tailwind CSS into the Shadow DOM
    const styleSheet = document.createElement('style');
    styleSheet.textContent = styles;
    this.shadowRoot.appendChild(styleSheet);

    const mountPoint = document.createElement('div');
    mountPoint.style.width = '100%';
    mountPoint.style.height = '100%';
    this.shadowRoot.appendChild(mountPoint);

    const primaryColor = this.getAttribute('primary-color');
    const shopId = this.getAttribute('shop-id');

    // Render the App in embed mode (hides nav/footer)
    createRoot(mountPoint).render(
      <React.StrictMode>
        <App isEmbed={true} primaryColor={primaryColor} shopId={shopId} />
      </React.StrictMode>
    );
  }
}

// Register the custom element if it hasn't been registered yet
if (!customElements.get('flower-order-form')) {
  customElements.define('flower-order-form', FlowerOrderForm);
}